import {
  Card,
  Col,
  DatePicker,
  Form,
  FormInstance,
  Input,
  InputNumber,
  Row,
} from 'antd';
import dayjs from 'dayjs';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Columns } from '../components/admin/Table';
import TableWithDrawer from '../components/admin/TableWithDrawer';
import PageHeader from '../components/base/PageHeader';
import {
  Album,
  GetAlbumsQuery,
  GetAlbumsQueryVariables,
  GetTagsQuery,
  GetTagsQueryVariables,
  Tag,
  useCreateAlbumMutation,
  useCreateTagMutation,
  useDeleteAlbumMutation,
  useDeleteTagMutation,
  useGetAlbumsQuery,
  useGetTagsQuery,
  useUpdateAlbumMutation,
  useUpdateTagMutation,
} from '../graphql/schema';
import formItemProps from '../helper/formItemProps';

const columns: Columns<Tag> = {
  name: 'Name',
};

interface FormFields {
  name: string;
  priority?: number;
}

const AlbumTags = () => {
  const { albumId } = useParams();
  const [create] = useCreateTagMutation();
  const [update] = useUpdateTagMutation();
  const [remove] = useDeleteTagMutation();

  const handleCreate = useCallback(
    async (values: FormFields) => {
      await create({
        variables: {
          dto: {
            name: values.name,
            priority: values.priority ?? 0,
          },
          albumId: albumId ?? '',
        },
      });
    },
    [create, albumId],
  );

  const handleUpdate = useCallback(
    async (id: string, values: FormFields) => {
      await update({
        variables: {
          id,
          dto: {
            name: values.name,
            priority: values.priority ?? 0,
          },
          albumId: albumId ?? '',
        },
      });
    },
    [update, albumId],
  );

  const handleDelete = useCallback(
    async (id: string) => {
      await remove({
        variables: {
          id,
          albumId: albumId ?? '',
        },
      });
    },
    [remove, albumId],
  );

  const formRenderer = (form: FormInstance) => {
    return (
      <Form layout="vertical" form={form}>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item {...formItemProps('name', 'Name', true)}>
              <Input placeholder="Name" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item {...formItemProps('priority', 'Priorität')}>
              <InputNumber />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  };

  return (
    <>
      <PageHeader title="Tags" />

      <TableWithDrawer<FormFields, Tag, GetTagsQuery, GetTagsQueryVariables>
        query={useGetTagsQuery}
        columns={columns}
        editFormRenderer={formRenderer}
        queryVariables={{
          albumId: albumId ?? '',
        }}
        singleItemTitle="Tag"
        onCreate={handleCreate}
        onUpdate={handleUpdate}
        onDelete={handleDelete}
        prepareFormValues={(item) => ({
          name: item.name ?? '',
          priority: item.priority ?? 0,
        })}
      />
    </>
  );
};

export default AlbumTags;
